import React, { useEffect, useState } from "react";
import FirebaseAnalytics from "../services/analytics.service";
import BillPaymentForm from "../views/bill-payment/bill-payment-index";
import BillPaymentCheckSecureLink from "../views/bill-payment/bill-payment-check-hash";

export default function BillPaymentUI(props) {
	const { history } = props;

	const [hasSecureLink, setHasSecureLink] = useState(false);

	useEffect(() => {
		FirebaseAnalytics.generic_event(12);
		if(localStorage.getItem("secure-link-id")) {
			setHasSecureLink(true);
		}
	}, [])

	const hasInvalidSecureId = () => {
		setHasSecureLink(false);
	}

	return (
		<div>

		{!hasSecureLink ?
			<BillPaymentForm props={props}/>
			:
			<BillPaymentCheckSecureLink props={props} history={history} secureId={localStorage.getItem("secure-link-id")} hasInvalidSecureId={hasInvalidSecureId}/>
        }
		</div>
	)
}